module.exports = __webpack_public_path__ + "img/53.b6b439e6.jpg";